export default __webpack_public_path__ + "static/media/DosimetristOff.8bf8da5d.svg";